(function () {
  'use strict';
  document.addEventListener('click', async function (event) {
    const remove = event.target.closest('[data-lynqr-configuration-id]');
    if (!remove) return;
    const configurationId = remove.getAttribute('data-lynqr-configuration-id');
    if (!configurationId) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } });
      const cart = await response.json();
      const updates = {};
      (cart.items || []).forEach((line) => {
        if (line.properties?.['_lynqr_configuration_id'] === configurationId) updates[line.key] = 0;
      });
      if (Object.keys(updates).length) {
        await fetch(`${root}cart/update.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ updates }) });
      }
      window.location.reload();
    } catch (error) {
      console.warn('[Lynqr][CART] Unable to remove grouped configuration', error);
      window.location.reload();
    }
  }, true);
})();
